<!-- 由 suu 创建于 2025-11-19 星期三 -->
<template>
  <van-popup v-model="vModelValue" :close-on-click-overlay="false">
    <div class="content-box">
      <div class="title">{{ title }}</div>
      <slot name="message" v-if="isSlot"></slot>
      <div
        class="message"
        v-html="message"
        v-else
        :style="{ fontSize: messageFontSize }"
      ></div>
      <div
        class="confirm-btn user-btn"
        @click="confirmClick"
        v-if="showConfirmButton"
      >
        {{ confirmText }}
      </div>
      <div
        class="cancel-btn user-btn"
        @click="cancelClick"
        v-if="showCancelButton"
      >
        {{ cancelText }}
      </div>
    </div>
  </van-popup>
</template>

<script>
import { Popup } from 'vant'
export default {
  name: 'BtwMessageBox',

  components: { [Popup.name]: Popup },

  props: {
    title: {
      type: String,
      default: ''
    },
    isSlot: {
      type: Boolean,
      default: false
    },
    message: {
      type: String,
      default: ''
    },
    messageFontSize: {
      type: String,
      default: ''
    },
    showCancelButton: {
      type: Boolean,
      default: false
    },
    showConfirmButton: {
      type: Boolean,
      default: true
    },
    confirmText: {
      type: String,
      default: '确定'
    },
    cancelText: {
      type: String,
      default: '取消'
    },
    cancelFn: {
      type: Function,
      default: () => {}
    },
    confirmFn: {
      type: Function,
      default: () => {}
    }
  },

  data() {
    return {
      vModelValue: true
    }
  },

  computed: {},

  watch: {},

  created() {},

  mounted() {},

  destroyed() {},

  methods: {
    confirmClick() {
      this.$emit('confirm')
      this.confirmFn()
    },
    cancelClick() {
      this.$emit('cancel')
      this.cancelFn()
    }
  }
}
</script>

<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 375) * 100vw;
}
.van-popup {
  background-color: transparent;
}
.content-box {
  width: vw(275);
  box-sizing: border-box;
  background: #ffffff;
  border-radius: vw(8);
  padding: vw(20);
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #050b27;
  .title {
    font-weight: 600;
    font-size: vw(18);
    margin-bottom: vw(15);
  }
  .message {
    font-weight: 400;
    font-size: vw(14);
    line-height: vw(20);
    text-align: center;
    color: rgba($color: #050b27, $alpha: 0.8);
    text-align: left;
    // /deep/ {
    //   .margin-top-10 {
    //     margin-top: vw(10);
    //   }
    //   .margin-top-20 {
    //     margin-top: vw(20);
    //   }
    //   .red-text {
    //     color: #ff2270;
    //     font-weight: 500;
    //   }
    // }
    ::v-deep {
      .margin-top-10 {
        margin-top: vw(10);
      }
      .margin-top-20 {
        margin-top: vw(20);
      }
      .red-text {
        color: #ff2270;
        font-weight: 500;
      }
      .bold-text {
        font-weight: 550;
      }
    }
  }
  .confirm-btn {
    width: 100%;
    height: vw(40);
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: vw(99);
    background: #ff2270;
    color: #fff;
    font-weight: 600;
    font-size: vw(14);
    margin-top: vw(20);
  }
  .cancel-btn {
    color: #050b27;
    font-weight: 400;
    font-size: vw(14);
    margin-top: vw(16);
  }
}
</style>
